var getAttributeFromTaggedParent = function getAttributeFromTaggedParent(el, parentTagName, attr) {
  var parent = el.parentElement;
  while (parent && parent.tagName !== parentTagName) {
    parent = parent.parentElement;
  }
  return parent ? parent.getAttribute(attr) || '' : '';
};
var findClosestAttribute = function findClosestAttribute(el, attr) {
  var currentEl = el;
  while (currentEl) {
    var value = currentEl.getAttribute(attr) || '';
    if (value) {
      return value;
    }
    currentEl = currentEl.parentElement;
  }
  return null;
};

export { findClosestAttribute, getAttributeFromTaggedParent };
